import { useAssistantEnabled } from 'features/onboarding/lib/useAssistantEnabled';
import { useScreenSize } from 'shared/lib/screen/useScreenSize';

/**
 * Whether the Inkeep widget gets to mount.
 *
 * Inkeep and the assistant are both an "Ask Truv AI" button docked bottom-right, so with the
 * assistant rolled out they stacked into two buttons over two different chats (CL-6818). The
 * assistant wins: its search_truv_docs tool answers from the same Inkeep-indexed documentation.
 *
 * Mobile drops it for the same reason the assistant's own launcher is desktop-only (CL-6540): a
 * floating bottom-right pill sits on top of the page's own controls on a phone — the orders list's
 * Next button lands right under it.
 */
export const useInkeepChatEnabled = (): boolean => {
  const assistantEnabled = useAssistantEnabled();
  const { isMobile } = useScreenSize();

  return !(assistantEnabled || isMobile);
};
